
import { mapState, mapMutations, mapActions } from 'vuex'
import moment from 'moment'
import Icon from '../common/Icon'

export default {
  name: 'OrderCard',
  components: {
    Icon
  },
  props: {
    order: {
      Type: Object,
      Default: {}
    }
  },
  data() {
    return {
      showTotals: null,
    }
  },
  computed: {
    ...mapState(['location']),
    ...mapState({
      locs: state => state.locations
    })
  },
  methods: {
    ...mapActions([ 'sendRequest', 'viewCart' ]),
    ...mapMutations([ 'setCart', 'setLoading', 'setErrors', 'setLocation' ]),
    getDate(date) {
      return moment(date).format('MM/DD/YYYY')
    },
    getTime(time) {
      return moment(time, 'H:mm').format('h:mm A')
    },
    setLocationsByMenuId(menu_id) {
      const locationsByMenuId = {}
      const all = this.locs.all
      for (let i = 0; i < all.length; i++) {
        let location = all[i]
        let cities = location.cities
        for (let j = 0; j < cities.length; j++) {
          let city = cities[j]
          let cityLocations = city.locations
          for (let k = 0; k < cityLocations.length; k++) {
            let loc = cityLocations[k]
            locationsByMenuId[loc.menu_id] = loc
          }
        }
      }
      this.setLocation(locationsByMenuId[menu_id])
    },
    async reorder(order) {
      
      if(!this.location || !this.location.address) {
        this.setLocationsByMenuId(order.menu_id)
      }
      
      if (order.id) {
        this.setLoading(true)
        const config = {
          method: 'post',
          url: 'orders',
          data: {
            id: order.id
          }
        }
        const response = await this.sendRequest(config)
        this.$utils.log(response)
        if(response.status === 'ok') {
          let cart = { ...response.data };
          if (cart.menu_id !== this.location.menu_id) {
            this.setLocationsByMenuId(cart.menu_id)
          }
          this.setCart(cart)
          if (cart.token) {
            commit('setToken', cart.token)
          }
          document.body.style.overflow = 'hidden'
          this.viewCart(cart)
        } else {
          this.setErrors(response.message)
        }
        this.setLoading(false)
      }
    },
    showSection(id) {
      if (this.showTotals === id) {
        this.showTotals = null
      } else {
        this.showTotals = id
      }
    },
    goToOrder(id) {
      this.$router.push(`/order/confirm/${id}`);
    }
  }
}
